import support from "./support.js";

export default {
  saveWebSetting(data) {
    return support.post("Web/saveWebSetting", data);
  },

  getWebSetting() {
    return support.get("Web/getWebSetting");
  },

  saveModelList(data) {
    return support.post("Web/saveModelList", data);
  },

  deleteModelList(data) {
    return support.post("Web/deleteModelList", data)
  },

}
